const cardItems = [
  {
    title: '2026夏季新番导览：这些免费漫画不容错过',
    desc: '夏季档新番阵容豪华，我们为你精选了十部必追的免费漫画作品，从热血战斗到治愈日常，总有一部适合你。',
    img: 'https://readdy.ai/api/search-image?query=A%20warm%20summer%20themed%20illustration%20with%20various%20comic%20book%20covers%20arranged%20artistically%2C%20sunlight%20streaming%20through%20window%2C%20cozy%20reading%20atmosphere%2C%20orange%20and%20golden%20tones%2C%20no%20text%2C%20editorial%20style&width=800&height=500&seq=card-info-01&orientation=landscape',
    tag: '新番推荐',
  },
  {
    title: '国产漫画出海成绩亮眼，多部作品海外热销',
    desc: '近年来国漫质量飞速提升，多部优秀国产漫画在日本、韩国及欧美市场取得亮眼成绩，国漫国际化步伐加速。',
    img: 'https://readdy.ai/api/search-image?query=A%20modern%20Chinese%20comic%20art%20style%20illustration%20with%20dynamic%20brushwork%2C%20traditional%20elements%20blended%20with%20modern%20design%2C%20warm%20amber%20and%20coral%20color%20palette%2C%20no%20text%2C%20clean%20composition&width=800&height=500&seq=card-info-02&orientation=landscape',
    tag: '行业动态',
  },
  {
    title: '下拉式阅读为何成为漫画阅读新趋势',
    desc: '相比传统翻页模式，下拉式阅读更符合移动端使用习惯，连续滚动带来更沉浸的阅读体验，已成为漫画平台标配。',
    img: 'https://readdy.ai/api/search-image?query=A%20smartphone%20displaying%20a%20vertical%20scrolling%20comic%20page%20with%20manga%20artwork%2C%20minimalist%20setup%20on%20a%20wooden%20desk%2C%20warm%20natural%20lighting%2C%20no%20text%2C%20modern%20tech%20lifestyle&width=800&height=500&seq=card-info-03&orientation=landscape',
    tag: '阅读体验',
  },
  {
    title: '从零开始学画漫画：新手入门全攻略',
    desc: '分镜、人体结构、透视原理、上色技巧……我们为你整理了一份漫画创作入门指南，助你迈出成为漫画家的第一步。',
    img: 'https://readdy.ai/api/search-image?query=An%20art%20studio%20desk%20with%20comic%20sketching%20tools%2C%20pencils%20and%20markers%2C%20half-finished%20manga%20style%20drawings%2C%20warm%20creative%20atmosphere%2C%20no%20text%2C%20artistic%20composition&width=800&height=500&seq=card-info-04&orientation=landscape',
    tag: '创作教程',
  },
  {
    title: '漫画社区最热讨论：哪部作品结局最意外',
    desc: '社区读者热议那些让人意想不到的漫画结局，从神转折到催泪收官，看看有没有你追过的作品上榜。',
    img: 'https://readdy.ai/api/search-image?query=A%20warm%20community%20discussion%20scene%20with%20speech%20bubbles%20and%20comic%20elements%20floating%2C%20abstract%20social%20interaction%20concept%2C%20orange%20and%20coral%20color%20scheme%2C%20no%20text%2C%20playful%20design&width=800&height=500&seq=card-info-05&orientation=landscape',
    tag: '社区热议',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          漫画资讯
        </h2>
        <p className="text-foreground-600 text-sm text-center mb-10 md:mb-14 max-w-xl mx-auto">
          最新的漫画行业动态与深度内容
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.slice(0, 3).map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl overflow-hidden group cursor-pointer hover:bg-background-200/60 transition-colors"
            >
              <div className="overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  title={item.title}
                  className="w-full aspect-[16/10] object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-2 py-1 rounded text-[10px] bg-accent-100 text-accent-700 font-medium mb-2">
                  {item.tag}
                </span>
                <h3 className="font-heading text-sm text-foreground-900 mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
          <div className="sm:col-span-2 lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {cardItems.slice(3).map((item, idx) => (
              <div
                key={idx + 3}
                className="bg-background-100 rounded-xl overflow-hidden group cursor-pointer hover:bg-background-200/60 transition-colors flex flex-col sm:flex-row"
              >
                <div className="sm:w-2/5 overflow-hidden shrink-0">
                  <img
                    src={item.img}
                    alt={item.title}
                    title={item.title}
                    className="w-full sm:h-full aspect-[16/10] sm:aspect-auto object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4 flex flex-col justify-center">
                  <span className="inline-block px-2 py-1 rounded text-[10px] bg-accent-100 text-accent-700 font-medium mb-2 self-start">
                    {item.tag}
                  </span>
                  <h3 className="font-heading text-sm text-foreground-900 mb-2 line-clamp-2">
                    {item.title}
                  </h3>
                  <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}